import api from './api';

export interface ActiveSessionItem {
  id?: number;
  session?: number;
  item_type: 'course' | 'exercise' | 'video' | 'newpage';
  course?: number | null;
  course_title?: string;
  course_thumbnail_url?: string;
  exercise?: number | null;
  exercise_pattern_title?: string;
  exercise_pattern_thumbnail_url?: string;
  video?: number | null;
  video_title?: string;
  video_thumbnail_url?: string;
  order: number;
}

export interface ActiveSession {
  id?: number;
  teacher?: number;
  student: number;
  student_data?: any;
  arrival_time: string;
  is_active: boolean;
  items?: ActiveSessionItem[];
  created_at?: string;
  updated_at?: string;
}

class ActiveSessionService {
  async getAll(params?: any): Promise<ActiveSession[]> {
    const response = await api.get('/active-sessions/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getActiveForTeacher(): Promise<ActiveSession[]> {
    const response = await api.get('/active-sessions/active_for_teacher/');
    return response.data;
  }

  async getById(id: number): Promise<ActiveSession> {
    const response = await api.get(`/active-sessions/${id}/`);
    return response.data;
  }

  async create(data: Partial<ActiveSession>): Promise<ActiveSession> {
    const response = await api.post('/active-sessions/', data);
    return response.data;
  }

  async update(id: number, data: Partial<ActiveSession>): Promise<ActiveSession> {
    const response = await api.patch(`/active-sessions/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/active-sessions/${id}/`);
  }

  async endSession(id: number): Promise<void> {
    await api.post(`/active-sessions/${id}/end_session/`);
  }

  async addItem(sessionId: number, item: Partial<ActiveSessionItem>): Promise<ActiveSessionItem> {
    const response = await api.post(`/active-sessions/${sessionId}/add_item/`, item);
    return response.data;
  }

  async reorderItems(sessionId: number, itemOrders: { id: number; order: number }[]): Promise<void> {
    await api.post(`/active-sessions/${sessionId}/reorder_items/`, { item_orders: itemOrders });
  }

  // Items management
  async createItem(item: Partial<ActiveSessionItem>): Promise<ActiveSessionItem> {
    const response = await api.post('/active-session-items/', item);
    return response.data;
  }

  async updateItem(id: number, item: Partial<ActiveSessionItem>): Promise<ActiveSessionItem> {
    const response = await api.patch(`/active-session-items/${id}/`, item);
    return response.data;
  }

  async deleteItem(id: number): Promise<void> {
    await api.delete(`/active-session-items/${id}/`);
  }

  async getItemsBySession(sessionId: number): Promise<ActiveSessionItem[]> {
    const response = await api.get('/active-session-items/', { params: { session: sessionId } });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }
}

const activeSessionService = new ActiveSessionService();
export default activeSessionService;
